export interface OAuthAttempt {
  companyId: string
  nonce: string
  createdAt: number
}

export const OAUTH_ATTEMPT_TTL = 15 * 60 * 1000

export const INSTAGRAM_OAUTH_KEY = '@Habitar:instagram-oauth'

export const buildOAuthState = (attempt: Pick<OAuthAttempt, 'companyId' | 'nonce'>): string => `${attempt.companyId}.${attempt.nonce}`

export function parseOAuthState(state: string | null | undefined): Pick<OAuthAttempt, 'companyId' | 'nonce'> | null {
  if (!state) return null
  const separator = state.lastIndexOf('.')
  if (separator <= 0 || separator === state.length - 1) return null
  return { companyId: state.slice(0, separator), nonce: state.slice(separator + 1) }
}

export function isOAuthAttemptValid(attempt: OAuthAttempt | null | undefined, state: string | null | undefined, now = Date.now()): boolean {
  const parsed = parseOAuthState(state)
  if (!attempt || !parsed) return false
  if (now - attempt.createdAt > OAUTH_ATTEMPT_TTL) return false
  return attempt.companyId === parsed.companyId && attempt.nonce === parsed.nonce
}
